.sticky-header {
    z-index: 10;
    flex-shrink: 0;
}
